import { useTranslation } from 'react-i18next'
import { LoginForm } from '@/components/features/auth'

export function LoginPage() {
  const { t } = useTranslation('auth')

  return (
    <div className="w-full max-w-md">
      <div className="mb-8 text-center">
        <h1 className="text-2xl font-bold">{t('welcomeBack')}</h1>
        <p className="text-muted-foreground">{t('loginSubtitle')}</p>
      </div>
      <LoginForm />
    </div>
  )
}
